import { literals } from "@/constants/literals";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

export interface CreateSectionsButtonsProps {
  dataSection: "order" | "packaging";
  isOut: boolean;
  continueCapture: (
    event: React.BaseSyntheticEvent<
      Event,
      EventTarget & HTMLFormElement,
      EventTarget
    >,
  ) => void;
  changeDataSection: () => void;
  isValidData: boolean;
  canChangeToPackage: boolean;
}

const CreateSectionsButtons = ({
  dataSection,
  isOut,
  continueCapture,
  changeDataSection,
  isValidData,
  canChangeToPackage,
}: CreateSectionsButtonsProps) => {
  return (
    <div className="py-4 flex flex-col gap-4 border-t border-ib-pt-color-gray-300 md:mx-14 md:items-center lg:mx-[calc((100%-797px)/2)]">
      {dataSection === "order" && !isOut ? (
        <div className="px-4 md:capture-button">
          <PrimaryButton
            size="medium"
            label={literals.continue}
            colour="red"
            disabled={!canChangeToPackage}
            type="button"
            onClick={changeDataSection}
          />
        </div>
      ) : null}
      {dataSection === "order" && isOut ? (
        <div className="px-4 md:capture-button">
          <PrimaryButton
            size="medium"
            label={literals.continue}
            colour="red"
            disabled={!isValidData}
            type="submit"
            onClick={continueCapture}
          />
        </div>
      ) : null}
      {dataSection === "packaging" ? (
        <div className="px-4 flex flex-col gap-y-4 md:px-0 md:w-full md:flex md:flex-row md:justify-center gap-x-6">
          <div className="md:capture-button">
            <SecondaryButton
              size="medium"
              label={literals.return}
              colour="red"
              onClick={changeDataSection}
            />
          </div>
          <div className="md:capture-button">
            <PrimaryButton
              size="medium"
              label={literals.continue}
              colour="red"
              disabled={!isValidData}
              type="submit"
              onClick={continueCapture}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default CreateSectionsButtons;
